import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import appRoutes from "../../routes/appRoutes";

import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import ICCheckbox from "../../components/form/checkbox";

const LoginForm = props => {
  const formik = useFormik({
    initialValues: {
      userName: "",
      password: "",
      rememberMeCheckbox: false
    },
    validationSchema: Yup.object({
      userName: Yup.string()
        .min(7, "Email must be of minimum length 7")
        .email("Please provide a valid email address")
        .required("Please enter the email address"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters long")
        .required("Please enter the password")
    }),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });
  return (
    <form
      className="d-flex flex-column align-items-center"
      onSubmit={formik.handleSubmit}
    >
      <ICInput
        id="userName"
        name="userName"
        type="text"
        label="Email Address *"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.userName}
        error={formik.touched.userName && formik.errors.userName ? true : false}
        helperText={
          formik.touched.userName && formik.errors.userName
            ? formik.errors.userName
            : ""
        }
      />
      <br />
      <ICInput
        id="password"
        name="password"
        type="password"
        label="Password *"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.password}
        error={formik.touched.password && formik.errors.password ? true : false}
        helperText={
          formik.touched.password && formik.errors.password
            ? formik.errors.password
            : ""
        }
      />
      <div className="rm-forget-container d-flex flex-row justify-content-between align-items-center flex-wrap">
        <p>
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px" }}
            name="rememberMeCheckbox"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.rememberMeCheckbox}
            inputProps={{ "aria-label": "primary checkbox" }}
            label="Remember Me"
          />
        </p>
        <p style={{ marginTop: "-8px" }}>
          <Link
            className="custom-label custom-link"
            to={appRoutes.forgotPassword}
          >
            Forgot your password?
          </Link>
        </p>
      </div>
      <br />
      <Button title="Login" type="submit" />
      <br />
      <Error>{props.serverErrorMsg}</Error>
    </form>
  );
};

export default LoginForm;

LoginForm.defaultProps = {
  serverErrorMsg: ""
};

LoginForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string
};
